// apps/web/src/layouts/components/SidebarAggregateBadge.tsx
//
// Badge do nó colapsado da sidebar admin: mostra a soma das pendências de toda a
// sua descendência visível. Some assim que o nó é aberto — aí o número passa a
// ser exibido pelo descendente colapsado seguinte, até chegar na folha.

import { useTranslation } from 'react-i18next';

import { SidebarCountBadge } from './SidebarCountBadge';

export interface SidebarAggregateBadgeProps {
  count: number;
  /** Compõe o `data-testid` (`sidebar-group-badge-<nodeKey>`). */
  nodeKey: string;
}

export function SidebarAggregateBadge({ count, nodeKey }: SidebarAggregateBadgeProps) {
  const { t } = useTranslation('admin');
  return (
    <SidebarCountBadge
      count={count}
      variant="muted"
      testId={`sidebar-group-badge-${nodeKey}`}
      label={t('sidebar.badges.group_pending', { count })}
    />
  );
}
